import { PERSISTED_QUERY_PARAMS_STORAGE_KEY } from './constants';

export const readBag = (): Record<string, Record<string, string>> => {
  try {
    return (
      JSON.parse(
        localStorage.getItem(PERSISTED_QUERY_PARAMS_STORAGE_KEY) ?? '{}'
      ) ?? {}
    );
  } catch {
    return {};
  }
};
